import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { env } from "@environments/environment";

export type RequestFiltersPayload = {
  [key: string]: any;
  filter: {
    nomenclatureId?: number[];
    organizationCode?: string[];
  };
  pageable: {
    page: number;
    size: number;
  };
};

export const RequestFilterKeys: { [key: string]: string } = {
  nomenclature: "nomenclatureId",
  tradeName: "tradeName",
  redistributionTreatmentProgram: 'direction',
  redistributionSeries: 'series',
  redistributionStatus: 'status',
  'due-date': 'dueDate'
};

@Injectable({
  providedIn: "root",
})
export class RedistributionsTableService {
  constructor(private http: HttpClient) {}

  private defaultRequestFiltersPayload: RequestFiltersPayload = {
    filter: {},
    pageable: {
      page: 0,
      size: 20,
    },
  };

  getBodyData(
    payload: Partial<RequestFiltersPayload> = this.defaultRequestFiltersPayload
  ): Observable<any> {
    const { filter, pageable } = payload;
    const fullPayload = {
      ...this.defaultRequestFiltersPayload.filter,
      ...filter,
    };
    
    let url = env.apiUrl + '/accounting/v1/redistribution-offer/filter?'  + `size=${
        pageable?.size || this.defaultRequestFiltersPayload.pageable.size
    }&page=${
        pageable?.page || this.defaultRequestFiltersPayload.pageable.page
    }`;
    
    return this.http.post<any>(url, fullPayload);
  }
}
